import React from "react";
import { Box, Grid, Slide, Typography, CardMedia } from "@mui/material";
import SwipeableTextMobileStepper from "./MobileStepper";
import { SecondaryStyle } from "../fonts";

import Carousel1Image1 from "../assets/Page2L1.webp";
import Carousel1Image2 from "../assets/Page2L2.webp";
import Carousel1Image3 from "../assets/Page2L3.webp";
import Carousel2Image1 from "../assets/Page2RA1.webp";
import Carousel2Image2 from "../assets/Page2RA2.webp";
import Carousel3Image1 from "../assets/Page2RBT1.webp";
import Carousel3Image2 from "../assets/Page2RBT2.webp";
import Carousel4Image1 from "../assets/Page2RBB1.webp";
import Carousel4Image2 from "../assets/Page2RBB2.webp";

//@ts-ignore
import RC from "../assets/Page2RC.mp4";

const carousel1Images = [Carousel1Image1, Carousel1Image2, Carousel1Image3];
const carousel2Images = [Carousel2Image1, Carousel2Image2];
const carousel3Images = [Carousel3Image1, Carousel3Image2];
const carousel4Images = [Carousel4Image1, Carousel4Image2];

const Page2 = (props) => {
  const { checked, isReverse } = props;

  return (
    <Slide
      direction={isReverse ? "right" : "left"}
      in={checked}
      timeout={{
        enter: 1750,
        exit: 1750,
      }}
    >
      <Box
        sx={{
          width: "100vw",
          height: { xs: "100%", sm: "100vh" },
          overflow: { xs: "auto", sm: "hidden" },
        }}
      >
        <Grid container sx={{ height: "100%" }} id="scrollTarget">
          {/* First Half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              <Grid item xs={12} sm={9.1}>
                <Grid
                  container
                  direction={"row"}
                  sx={{ height: { xs: "35.5vh", sm: "100%" } }}
                >
                  {/* LD/LA/*/}
                  <Grid
                    item
                    xs={12}
                    sx={{
                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: ".1vh solid #fff",
                      },
                      borderTop: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                    }}
                  >
                    <SwipeableTextMobileStepper
                      images={carousel1Images}
                      showArrows={true}
                      showDots={true}
                      autoplay={true}
                    />
                  </Grid>
                </Grid>

                {/* LB */}
                <Grid
                  item
                  xs={12}
                  sx={{
                    borderTop: {
                      xs: ".5vh solid #fff",
                      sm: "none",
                    },
                    borderRight: {
                      xs: "none",
                      sm: ".5vh solid #fff",
                    },
                    display: "flex",
                    pb: { xs: 1.5 },
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      ...SecondaryStyle,
                      textAlign: "justify",
                      "@media (orientation: landscape)": {
                        fontSize: { xs: "1vw", md: "1vw", lg: "1vw" },
                        lineHeight: { xs: "1.1vw", md: "1.1vw", lg: "1.1vw" },
                        paddingTop: "2vw",
                        paddingRight: "2vw",
                        paddingLeft: { xs: "2vh", sm: "2vw" },
                      },
                      "@media (orientation: portrait)": {
                        fontSize: {
                          xs: "1.7vh",
                          sm: "1vh",
                        },
                        lineHeight: {
                          xs: "2vh",
                          sm: "1.65vh",
                          md: "1.5vh",
                          lg: "1.8vh",
                        },
                        paddingTop: {
                          xs: "1vh",
                          sm: "2.2vh",
                          md: "1.2vh",
                          lg: "0vh",
                        },
                        px: { xs: "1.5vh", sm: "5vh" },
                      },
                    }}
                  >
                    This beautifully designed kitchen offers a perfect blend of
                    style and function, creating a space that feels both
                    luxurious and welcoming. High-end stainless steel appliances
                    and sleek fixtures bring a modern touch, while ample counter
                    space and open shelving make it easy to cook and entertain.
                    Bathed in natural light, this kitchen invites you to enjoy
                    morning coffee or a relaxed dinner, making it the true heart
                    of this unique laneway home. Whether you're hosting friends
                    or enjoying a quiet meal, this kitchen is crafted for
                    comfort and connection.
                  </Typography>
                </Grid>
              </Grid>
              {/* LC/LB */}
            </Grid>
          </Grid>

          {/* 2nd half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    height: { xs: "36vh", sm: "50vh" },
                  }}
                >
                  {/**RC */}
                  <Grid
                    item
                    xs={12}
                    sx={{
                      borderBottom: ".5vh solid #fff",
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderRadius: { xs: "16px", sm: "0vh" },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                    }}
                  >
                    <SwipeableTextMobileStepper images={carousel2Images} />
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    borderTop: ".5vh solid #fff",
                    height: {
                      sm: "100%",
                    },
                  }}
                >
                  {/* RD */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderRadius: { xs: "16px", sm: "0vh" },
                      height: { xs: "45vh", sm: "50vh" },

                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                    }}
                  >
                    <CardMedia
                      component={"video"}
                      sx={{
                        borderRadius: { xs: "16px", sm: "0vh" },
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "50% 90%",
                      }}
                      src={RC}
                      autoPlay
                      muted
                      loop
                      playsInline
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderBottom: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderTop: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },

                      height: {
                        xs: "74.5vh",
                        sm: "100%",
                      },
                      maxHeight: { xs: "100%", sm: "50vh" },
                    }}
                  >
                    <Box
                      sx={{
                        height: { xs: "36vh", sm: "25vh" },
                        borderRadius: { xs: "16px", sm: "0vh" },

                        borderBottom: {
                          xs: ".5vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                      }}
                    >
                      <SwipeableTextMobileStepper
                        images={carousel3Images}
                        autoplay={false}
                      />
                    </Box>

                    <Box
                      sx={{
                        height: { xs: "36vh", sm: "25vh" },

                        borderRadius: { xs: "16px", sm: "0vh" },
                        borderTop: ".5vh solid #fff",
                      }}
                    >
                      <SwipeableTextMobileStepper
                        images={carousel4Images}
                        autoplay={false}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Slide>
  );
};

export default Page2;
